import React, { useMemo } from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getHamsKey } from '../../../services/product-to-hams-key';
import { ModalEntryPoint } from '../shared/modal-entry-point';
import { DIALOG_CONFIG } from './dialog-config';
import entryPoint, { type EntryPointParams } from './standardStorageHardLimit.entrypoint';

export function StandardStorageHardLimitModal(): React.JSX.Element {
	const { cloudId, product } = useEditionAwareness();

	const entryPointParams: EntryPointParams = useMemo(
		() => ({ cloudId, hamsProductKey: getHamsKey(product) }),
		[cloudId, product],
	);

	const modalProps = useMemo(() => ({ width: 968, height: 560 }), []);

	return (
		<ModalEntryPoint
			modalProps={modalProps}
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
